import { Application } from "@hotwired/stimulus"
import "../turbo/frame_missing_fallback.js"
import "../turbo/cable_session_guard.js"

const application = Application.start()

import controllers from "./**/*_controller.js"
import lazyControllers from "lazy-stimulus-controllers"
import { lazyLoadControllers } from "./lazy_loader.js"

controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})
lazyLoadControllers(application, lazyControllers)

// Microtip keeps the tooltip visible while the trigger has :focus, so a click
// would leave it open until the user clicks elsewhere. Blurring on click hides
// it once the cursor leaves.
document.addEventListener("click", (event) => {
  const tooltip = event.target.closest('[role="tooltip"]')
  if (tooltip) tooltip.blur()
})
